import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaMemberEntitlements } from '@/service/tuina'

export const fetchTuinaMemberEntitlements = createAsyncThunk(
  'tuinaMemberEntitlements/fetchTuinaMemberEntitlements',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaMemberEntitlements(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载可服务项目失败'
      )
    }
  }
)

const memberEntitlementsSlice = createSlice({
  name: 'tuinaMemberEntitlements',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaMemberEntitlements.pending, (state) => {
        state.fetching = true
        state.error = null
        state.data = []
      })
      .addCase(fetchTuinaMemberEntitlements.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || []
      })
      .addCase(fetchTuinaMemberEntitlements.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default memberEntitlementsSlice.reducer
